import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon/SvgIcon';

const ExcelIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.2976 11.5125L6.6499 10.05V20.8567C6.65 20.9741 6.67419 21.0904 6.72109 21.1988C6.76798 21.3072 6.83666 21.4057 6.92321 21.4887C7.00976 21.5716 7.11248 21.6374 7.2255 21.6822C7.33852 21.7271 7.45964 21.7501 7.58193 21.75H22.5038C22.6262 21.7503 22.7475 21.7274 22.8607 21.6827C22.9739 21.6379 23.0768 21.5722 23.1635 21.4892C23.2503 21.4062 23.3191 21.3077 23.3661 21.1991C23.4131 21.0906 23.4373 20.9743 23.4374 20.8567V16.875L15.2976 11.5125Z"
      fill="#185C37"
    />
    <path
      d="M15.2976 2.25H7.58193C7.45964 2.2499 7.33852 2.27293 7.2255 2.31776C7.11248 2.3626 7.00976 2.42837 6.92321 2.51132C6.83666 2.59426 6.76798 2.69276 6.72109 2.80119C6.67419 2.90962 6.65 3.02585 6.6499 3.14325V7.125L15.2976 12L19.8765 13.4625L23.4374 12V7.125L15.2976 2.25Z"
      fill="#25AA51"
    />
    <path d="M6.6499 7.125H15.2976V12H6.6499V7.125Z" fill="#107C41" />
    <path
      opacity="0.1"
      d="M12.839 6.14996H6.6499V18.3375H12.839C13.0856 18.3363 13.3218 18.2419 13.4964 18.0747C13.671 17.9075 13.7699 17.681 13.7718 17.4442V7.04321C13.7699 6.80647 13.671 6.57995 13.4964 6.41276C13.3218 6.24556 13.0856 6.15114 12.839 6.14996Z"
      fill="#0A0A0A"
    />
    <path
      opacity="0.2"
      d="M12.3304 6.63751H6.6499V18.825H12.3304C12.577 18.8238 12.8132 18.7294 12.9878 18.5622C13.1624 18.395 13.2613 18.1685 13.2632 17.9318V7.53076C13.2613 7.29402 13.1624 7.0675 12.9878 6.90031C12.8132 6.73311 12.577 6.63869 12.3304 6.63751Z"
      fill="#0A0A0A"
    />
    <path
      opacity="0.2"
      d="M12.3304 6.63751H6.6499V17.85H12.3304C12.577 17.8488 12.8132 17.7544 12.9878 17.5872C13.1624 17.42 13.2613 17.1935 13.2632 16.9568V7.53076C13.2613 7.29402 13.1624 7.0675 12.9878 6.90031C12.8132 6.73311 12.577 6.63869 12.3304 6.63751Z"
      fill="#0A0A0A"
    />
    <path
      opacity="0.2"
      d="M11.8218 6.63751H6.6499V17.85H11.8218C12.0684 17.8488 12.3046 17.7544 12.4792 17.5872C12.6538 17.42 12.7527 17.1935 12.7546 16.9568V7.53076C12.7527 7.29402 12.6538 7.0675 12.4792 6.90031C12.3046 6.73311 12.0684 6.63869 11.8218 6.63751Z"
      fill="#0A0A0A"
    />
    <path
      d="M2.49531 6.63751H11.8219C12.0689 6.63731 12.306 6.73129 12.4809 6.89878C12.6558 7.06628 12.7543 7.29359 12.7547 7.53076V16.4693C12.7543 16.7064 12.6558 16.9337 12.4809 17.1012C12.306 17.2687 12.0689 17.3627 11.8219 17.3625H2.49531C2.37295 17.3627 2.25175 17.3398 2.13864 17.295C2.02553 17.2502 1.92272 17.1844 1.83609 17.1015C1.74946 17.0185 1.6807 16.92 1.63376 16.8115C1.58682 16.703 1.5626 16.5867 1.5625 16.4693V7.53076C1.5626 7.4133 1.58682 7.297 1.63376 7.18853C1.6807 7.08005 1.74946 6.98152 1.83609 6.89856C1.92272 6.81561 2.02553 6.74985 2.13864 6.70506C2.25175 6.66027 2.37295 6.63732 2.49531 6.63751Z"
      fill="url(#paint0_linear_664_39123)"
    />
    <path
      d="M4.45312 14.9047L6.41484 11.9917L4.61797 9.09521H6.06094L7.04141 10.95C7.13203 11.1255 7.19766 11.256 7.22734 11.343H7.24063C7.30469 11.202 7.37266 11.0662 7.44375 10.9335L8.49219 9.09821H9.82031L7.97734 11.9782L9.86719 14.907H8.45391L7.32109 12.8737C7.2685 12.7863 7.2238 12.6947 7.1875 12.6H7.16875C7.13572 12.6923 7.09168 12.7806 7.0375 12.8632L5.87109 14.9047H4.45312Z"
      fill="white"
    />
    <path
      d="M22.5044 2.25H15.2974V7.125H23.4372V3.14325C23.4371 3.02579 23.4129 2.90949 23.3659 2.80102C23.319 2.69254 23.2503 2.59401 23.1636 2.51105C23.077 2.4281 22.9742 2.36234 22.8611 2.31755C22.748 2.27276 22.6268 2.2498 22.5044 2.25Z"
      fill="#33C481"
    />
    <path d="M15.2974 12H23.4372V16.875H15.2974V12Z" fill="#107C41" />
    <defs>
      <linearGradient
        id="paint0_linear_664_39123"
        x1="3.51094"
        y1="5.93551"
        x2="10.3687"
        y2="18.307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset="0.5" stopColor="#117E43" />
        <stop offset="1" stopColor="#0B6631" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export default ExcelIcon;
